import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-controls',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './modal-controls.component.html',
  styleUrl: './modal-controls.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalControlsComponent {
  public readonly terminateDisabledCondition = input<boolean>(false);
  public readonly secondaryActionTextKey = input.required<string>();
  public readonly primaryActionTextKey = input.required<string>();

  public readonly secondaryActionTriggered = output();
  public readonly primaryActionTriggered = output();

  public secondaryAction(): void {
    this.secondaryActionTriggered.emit();
  }

  public primaryAction(): void {
    this.primaryActionTriggered.emit();
  }
}
